import PropTypes from 'prop-types';

import Logo from '../Logo';
import Message from '../Message';
import * as Styled from './MessageWithLogo.style';

/**
 * A component for displaying message blocks with a logo at the top and consistent styling
 * @param {object} props - Component props
 * @param {string} props.message - The message text to display
 * @param {string} [props.type='primary'] - The type/color of message for styling
 * @param {string} [props.size='sm'] - The size of the message text
 * @param {string} [props.variant='plain'] - The variant for styling (plain or card)
 * @param {string} [props.logoSrc='/s2/vector/velo-logo-horizontal-green.svg'] - The source of the logo
 */

function MessageWithLogo({
  message,
  type = 'primary',
  size = 'md',
  variant = 'card',
  logoSrc = '/s2/vector/velo-logo-horizontal-green.svg'
}) {
  return (
    <Styled.MessageRoot variant={variant}>
      <Styled.LogoContainer>
        <Logo src={logoSrc} />
      </Styled.LogoContainer>
      <Message message={message} size={size} type={type} variant="plain" />
    </Styled.MessageRoot>
  );
}

MessageWithLogo.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['primary', 'secondary', 'info', 'warning', 'error', 'success']),
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl']),
  variant: PropTypes.oneOf(['plain', 'card']),
  logoSrc: PropTypes.string
};

export default MessageWithLogo;
